/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-props-destruction */
/**
 * @author Vladislavs Zimnikovs <vladislavs.zimnikovs@scandiweb.com>
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package puma-mx
 */

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ProductColorAttributeComponent from 'Component/ProductColorAttribute/ProductColorAttribute.component';
import ProductConfigurableAttributesContainer
from 'Component/ProductConfigurableAttributes/ProductConfigurableAttributes.container';

/** @namespace Scandipwa/Component/ProductColorAttribute/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    use_thumbnail_as_swatch: state.ConfigReducer.use_thumbnail_as_swatch
});

/** @namespace Scandipwa/Component/ProductColorAttribute/Container/mapDispatchToProps */
// eslint-disable-next-line no-unused-vars
export const mapDispatchToProps = (dispatch) => ({});

/** @namespace Scandipwa/Component/ProductColorAttribute/Container */
export class ProductColorAttributeContainer extends ProductConfigurableAttributesContainer {
    static propTypes = {
        ...super.propTypes,
        use_thumbnail_as_swatch: PropTypes.bool
    };

    static defaultProps = {
        ...super.defaultProps,
        use_thumbnail_as_swatch: false
    };

    render() {
        return (
            <ProductColorAttributeComponent
              { ...this.props }
              { ...this.containerFunctions }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductColorAttributeContainer);
